<template>
  <div class="kept-items-unavailable" v-if="isVisible">
    <i class="fa fa-info-circle kept-items-unavailable__icon" aria-hidden="true"></i>
    <p class="kept-items-unavailable__text">
      {{ $translate('Bigtex5::Template.keptItemsUnavailableNotice', { count: count }) }}
    </p>
  </div>
</template>

<script>
/**
 * Hinweis auf behaltene Artikel dieser Kategorie, die es nicht mehr zu kaufen
 * gibt. Ohne ihn steht ein Kunde, dessen gekaufte Artikel alle ausverkauft
 * sind, mit aktivem Filter vor einer leeren Kategorie und haelt den Filter fuer
 * kaputt.
 *
 * Die Daten liefert die Spotlight-API (unavailable_count / unavailable_items)
 * ueber App.keptItemsUnavailable. Genutzt wird davon nur die Anzahl - welche
 * Artikel es betrifft, hilft dem Kunden hier nicht weiter, er kann sie ohnehin
 * nicht kaufen.
 *
 * Bewusst OHNE Props: die Komponente sitzt im ShopBuilder in einem
 * Code-Widget, dort gibt es kein Twig und damit keine Werte zum Durchreichen.
 * Alles, was sie braucht, holt sie sich selbst aus App und der URL.
 */
export default {
  computed: {
    isLoggedIn() {
      return this.$store.state.user.userData !== null && this.$store.state.user.userData.id > 0;
    },

    data() {
      return App.keptItemsUnavailable || { count: 0, items: [] };
    },

    count() {
      return parseInt(this.data.count, 10) || 0;
    },

    // Nur bei aktivem Filter: ohne ihn zeigt die Kategorie ohnehin alles, was
    // es gibt - der Hinweis waere dort nur Rauschen.
    isVisible() {
      return this.isLoggedIn && this.count > 0 && this.isFilterActive;
    },

    isFilterActive() {
      if (typeof window === 'undefined') {
        return false;
      }

      return new URLSearchParams(window.location.search).get('nur_gekauft') === '1';
    }
  }
};
</script>
